import { render, staticRenderFns } from "./BaseRouterLink.vue?vue&type=template&id=1b0821ca"
import script from "./BaseRouterLink.vue?vue&type=script&lang=js"
export * from "./BaseRouterLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports